import { PresentationProcessingApiService } from '../services/presentations-management';
import { getCurrentOrg } from './getCurrentOrg';
import { OpenAPI as PresentationsManagement } from '../services/presentations-management';
import { type PresentationDto } from '../services/presentations-management';

export type PresentationData = PresentationDto;

export type GetPresentationsPayload = {
  search?: string;
  page?: number;
  size?: number;
  sort?: Array<string>;
};

export type CreatePresentationPayload = {
  title: string;
  description: string;
  file: File;
};

export type UpdatePresentationPayload = {
  id: string;
  data: {
    title?: string;
    description?: string;
  };
};

export const getPresentations = async (payload: GetPresentationsPayload) => {
  const { search, page, size, sort } = payload;

  const response = await PresentationProcessingApiService.getPresentations(
    getCurrentOrg(),
    search,
    page,
    size,
    sort
  );

  return {
    content: response.content || [],
    totalElements: response.totalElements || 0,
    total: response.totalElements || 0,
  };
};

export const createPresentation = async (
  payload: CreatePresentationPayload
) => {
  const { title, description, file } = payload;
  const token = PresentationsManagement.TOKEN;

  const form = new FormData();
  form.append('file', file);
  form.append(
    'request',
    new Blob(
      [
        JSON.stringify({
          title,
          description,
        }),
      ],
      {
        type: 'application/json',
      }
    )
  );

  const baseUrl =
    process.env.NODE_ENV === 'development'
      ? '/app'
      : process.env.REACT_APP_BILLING_BASE_API_URL;

  const response = await fetch(`${baseUrl}/presentations`, {
    method: 'POST',
    headers: {
      'x-ai-agent-organization-context': getCurrentOrg(),
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: form,
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const updatePresentation = async (
  payload: UpdatePresentationPayload
) => {
  const { id, data } = payload;

  return await PresentationProcessingApiService.updatePresentation(
    getCurrentOrg(),
    id,
    data
  );
};

export const deletePresentation = async (presentationId: string) => {
  return await PresentationProcessingApiService.deletePresentation(
    getCurrentOrg(),
    presentationId
  );
};

export const getPresentationById = async (presentationId: string) => {
  return await PresentationProcessingApiService.getPresentation(
    getCurrentOrg(),
    presentationId
  );
};
